
export const ExternalOrderListPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">발주 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select w-150px">
                                <option>전체</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">발주일자</label>
                            <div className="frm_field input_date">
                                <input type="date" className="form-control" />
                                <span className="txt_range">~</span>
                                <input type="date" className="form-control me-0" />
                                <button className="btn btn-info btn_search">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">발주 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>
                        <button className="btn btn-primary w-80px px-0 ms-40px">발행 신청</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th rowSpan={2} style={{ width: "4.4%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            onChange={(e) => console.log(e.target.checked)}
                                        />
                                    </div>
                                </th>
                                <th>발주일자</th>
                                <th>요청자</th>
                                <th>담당자</th>
                                <th>품목</th>
                                <th>규격<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" /></th>
                                <th>수량</th>
                                <th>환종</th>
                                <th>금액</th>
                                <th>결제일</th>
                                <th>상태<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => (
                                <tr>
                                    <td style={{ width: "2.85%" }}>
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        e.target.parentElement.parentElement.parentElement.classList.add("lightblue");
                                                    } else {
                                                        e.target.parentElement.parentElement.parentElement.classList.remove("lightblue");
                                                    }
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td style={{ width: "10.71%" }} className="text-center">2024-05-05</td>
                                    <td style={{ width: "10.71%" }} className="text-center">김김김</td>
                                    <td style={{ width: "8.57%" }} className="text-center"></td>
                                    <td style={{ width: "16.42%" }} className="text-center">CSP영구라이선스</td>
                                    <td style={{ width: "12.14%" }} className="text-center"></td>
                                    <td style={{ width: "6.42%" }} className="text-center">1</td>
                                    <td style={{ width: "6.42%" }} className="text-center">KRW</td>
                                    <td style={{ width: "7.85%" }} className="text-center"></td>
                                    <td style={{ width: "8.57%" }} className="text-center">매월 말일</td>
                                    <td className="text-center">발주</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}